import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { useEffect, type FC } from "react";
import { useAccountId } from "../../../generic/hooks/use-account-id";
import { type ToTarget } from "../../../to/to-target";
import { getSurveyIdFromUrl, makeSurveyUrl } from "../components/utils/survey-url";
import { $isButtonListNode } from "../nodes/button-list-node";
import { $findAllNodesOfType } from "../utils/find-all-nodes-of-type";

export const SurveyLinkToTargetSwitchPlugin: FC<{ toTarget: ToTarget["toTarget"] }> = ({
  toTarget,
}) => {
  const [editor] = useLexicalComposerContext();
  const account_id = useAccountId();

  useEffect(() => {
    if (!account_id) return;

    editor.update(() => {
      const channel_mode = toTarget === "channel";
      $findAllNodesOfType($getRoot(), $isButtonListNode).forEach((buttonList) => {
        const newButtons = buttonList.__buttons.map((button) => {
          const oldUrl = button.url;

          const survey_id = getSurveyIdFromUrl(oldUrl);
          if (!survey_id) return button;

          const newUrl = makeSurveyUrl(account_id, survey_id, { anonymous: channel_mode });

          if (oldUrl === newUrl) return button;

          return { ...button, url: newUrl };
        });

        buttonList.setButtons(newButtons);
      });
    });
  }, [toTarget, editor, account_id]);

  return null;
};
